import { Slider } from "@ui/slider";
import React from "react";

interface Props {
  defaultValue?: number[];
  value?: number[];
  disabled?: boolean;
  onValueChange?: (value: number[]) => void;
  onValueCommit?: (value: number[]) => void;
  inverted?: boolean;
  min?: number;
  max?: number;
  step?: number;
  minStepsBetweenThumbs?: number;
  className?: string;
  trackClassName?: string;
  rangeClassName?: string;
  thumbClassName?: string;
  thumbContent?: React.ReactNode;
}

const BasicSlider = ({
  defaultValue,
  value,
  disabled,
  onValueChange,
  onValueCommit,
  inverted,
  min,
  max,
  step,
  minStepsBetweenThumbs,
  className,
  trackClassName,
  rangeClassName,
  thumbClassName,
  thumbContent,
}: Props) => {
  return (
    <Slider
      defaultValue={defaultValue}
      value={value}
      disabled={disabled}
      onValueChange={onValueChange}
      onValueCommit={onValueCommit}
      inverted={inverted}
      min={min}
      max={max}
      step={step}
      minStepsBetweenThumbs={minStepsBetweenThumbs}
      className={className}
      trackClassName={trackClassName}
      rangeClassName={rangeClassName}
      thumbClassName={thumbClassName}
      thumbContent={thumbContent}
    />
  );
};

export default BasicSlider;
